module.exports = __webpack_public_path__ + "static/img/2.b7514cad.png";